import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import StokAraPage from './StokAraPage';
import TeknikServisStoklariPage from './TeknikServisStoklariPage';

const TABS = [
  { key: 'stok-ara', label: 'Stok Arama' },
  { key: 'teknik-servis-stoklari', label: 'Teknik Servis Stokları' },
];

const StokYonetimiPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = TABS.some((t) => t.key === tabParam) ? tabParam : TABS[0].key;

  const setActiveTab = (key) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  useEffect(() => {
    if (!tabParam || !TABS.some((t) => t.key === tabParam)) {
      setSearchParams({ tab: TABS[0].key }, { replace: true });
    }
  }, [tabParam, setSearchParams]);

  return (
    <main className="main-content">
      <div className="content-header">
        <h1>Stok Yönetimi</h1>
      </div>

      <div className="tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-panel">
        {activeTab === 'stok-ara' && <StokAraPage embedded />}
        {activeTab === 'teknik-servis-stoklari' && <TeknikServisStoklariPage embedded />}
      </div>
    </main>
  );
};

export default StokYonetimiPage;
